import React from 'react';
import { Action } from 'redux';
import {
  GET_PREFERENCE_ERROR,
  GET_PREFERENCE_REQUEST,
  GET_PREFERENCE_SUCCESS,
  PreferenceDispatchTypes,
  PreferenceType
} from '../constants/PreferenceActionType';

interface DefaultState {
  loading: boolean;
  prefernceList?: PreferenceType;
  totalCount?: any;
}

const initialState: DefaultState = {
  loading: false,
  totalCount: 0
};

const PreferenceReducer = (
  state: DefaultState = initialState,
  action: PreferenceDispatchTypes
): DefaultState => {
  switch (action.type) {
    case GET_PREFERENCE_REQUEST:
      return {
        // ...state,
        loading: true
      };

    case GET_PREFERENCE_SUCCESS:
      return {
        // ...state,
        loading: false,
        // totalCount: action.totalCount,
        prefernceList: action.payload
      };

    case GET_PREFERENCE_ERROR:
      return {
        // ...state,
        loading: false
        // error: action.payload
      };

    default:
      return state;
      break;
  }
};

export default PreferenceReducer;
